import { useObserver } from 'mobx-react-lite';
import { useStores } from 'src/hooks/use-stores';

type PusherStore = ReturnType<typeof useStores>['Pusher'];

export default function usePusher(): PusherStore {
  const stores = useStores();
  return useObserver(() => stores.Pusher);
}
